import { Row, StatusTable } from "@egovernments/digit-ui-react-components";
import React from "react";

const SplittedFeeData = ({ splittedFeeData, t }) => {
    return (
      <StatusTable>
        {splittedFeeData.map((item, index) => (
        Object.entries(item).map(([key, value]) => 
          key !== "estimateAmount" && (
          <Row
            key={`${index}_${key}`} 
            className="border-none"
            label={t(`BPA_COMMON_${key.toUpperCase()}_FEE`)}
            text={`₹ ${value || "0"}`}
          />
        ))
      ))}
      </StatusTable>   
    );
  };

export default SplittedFeeData